export const SET_AUTHENTICATING = "authenticatingUser/SET_AUTHENTICATING";

export const setAuthenticating = (authenticating: boolean) => ({
  type: SET_AUTHENTICATING,
  payload: { authenticatingUser: authenticating },
});
